<div 
  class="SelectNewFlight-message-info-init d-flex text-am-white" 
  [ngClass]="{'select': flight.selected}"
  (click)="activeContinue(flight)">
  <div class="content-flight-itinerary">
    <app-am-flight-itinerary [isrb]="true" [segments]="flightSeg.segments" [showDuration]="false"></app-am-flight-itinerary>
  </div>
  <div class="SelectNewFlight-routeFlight" *ngIf="msj == 'srIrops.reviewConfirm.withOutScales'">
    <span class="fs-24px lh-32px fw-light-x d-flex gap-2">
      {{ firstSegment.marketingCarrier + ' ' + firstSegment.marketingFlightCode }}
    </span>
    <span class="fs-20px lh-32px fw-light-x text-white-75">
      {{ msj | translate }} {{this.time}}
    </span>
  </div>
  <div class="SelectNewFlight-routeFlight fw-regular"  *ngIf="msj != 'srIrops.reviewConfirm.withOutScales'">
    <span class="fs-32px lh-32px  d-flex gap-2">
      {{ firstSegment.marketingCarrier + ' ' + firstSegment.marketingFlightCode }} <span *ngIf="lastSegment.aircraftType != undefined">, {{ lastSegment.marketingCarrier + ' ' + lastSegment.marketingFlightCode }}</span>
    </span>
    <span class="fs-24px lh-32px fw-regular  text-am-white">
     {{segments.length -1}} {{ msj | translate  }} {{this.time}}
    </span>
  </div>
</div>
